import React from 'react';
import MainLogo from '../Common/MainLogo';

const ModalWrapper = ({ children, isOpen, onClose, isBottomButton, size, type, noScroll, mobileAlignTop }) => {
  return (
    <div
      className={`modal-all-wrapper ${isOpen ? 'is-show' : ''} ${isBottomButton ? 'is-bottom-button' : ''} ${
        size === 'sm' ? 'is-small' : ''
      } ${type === 'download' ? 'type-download' : ''} ${mobileAlignTop ? 'is-mobile-align-top' : ''}`}
    >
      <div className={'modal-dim-overlay'} onClick={onClose} />
      <div className={'modal-wrapper'}>
        <div className='modal-top-wrapper'>
          <div className='modal-left-wrapper'>
            <MainLogo typeSmaller={true} />
          </div>
          <div className='modal-right-wrapper'>
            <button
              type={'button'}
              className={'button-default modal-close-button'}
              onClick={onClose}
              aria-label={'Close'}
            >
              <i className={'icon icon-close-wh'} />
            </button>
          </div>
        </div>
        <div className={`modal-content-wrapper component-custom-scroll ${noScroll ? 'type-no-scroll' : ''}`}>
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default ModalWrapper;
